import validatorBuilder from 'validator-builder';

let associeValidator = null;

export default class Associe {
    constructor(data) {
        data = data || {};
        this.id = data.id;
        this.code = data.code;
        this.libelle = data.libelle;
    }

    isValid() {
        associeValidator = associeValidator || validatorBuilder.getInstanceFor('Associe');
        const validationResults = associeValidator.validate(this);
        return validationResults.isValid;
    }
}
